import PublicHttpClient from '../../services/public-http-client';
import { Pagination } from '../../../model/pagination';
import { IPaymentPagedRequest } from '../../../model/sge/payment/request/payment-paged-request';
import { IPaymentResponse } from '../../../model/sge/payment/response/payment-response';

const basePath = (clientId: number, liquidationId: number) => `Public/Client/${clientId}/Liquidations/${liquidationId}/Payments`;

const list = async (clientId: number, liquidationId: number, params: Omit<IPaymentPagedRequest, 'liquidationId'>): Promise<Pagination<IPaymentResponse>> => {
    return await PublicHttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(clientId, liquidationId)}`,
        params
    }).then((response) => Object.assign(new Pagination<IPaymentResponse>(), response.data));
};

const PublicPaymentAppService = { list };
export default PublicPaymentAppService;
